import createTheme from '@material-ui/core/styles/createTheme';
import {
  KOBOO_BLUE, KOBOO_DARK_GREY, KOBOO_GREY,
  KOBOO_LIGHT_BLUE,
  KOBOO_LIGHT_GREY,
  KOBOO_OTHER_BLUE,
} from '../constants/colors';

export const theme = createTheme({
  palette: {
    primary: {
      light: KOBOO_LIGHT_BLUE,
      main: KOBOO_BLUE,
      dark: KOBOO_OTHER_BLUE,
    },
    secondary: {
      light: KOBOO_LIGHT_GREY,
      main: KOBOO_GREY,
      dark: KOBOO_DARK_GREY,
    },
    action: {
      selected: KOBOO_BLUE,
    }
  },
  overrides: {
    MuiTable: {
      root: {
        tableLayout: "fixed",
        minWidth: '100%',
        overflow: 'auto'
      }
    },
    MuiTableRow: {
      root: {
        width: '100%',
        backgroundColor: 'white',
        color: 'black',
        transition: 'background-color 0.2s, color 0.2s',
      },
      hover: {
          backgroundColor: 'white',
          '&:nth-of-type(odd)': {
            backgroundColor: "#FDFDFD",
          },
      },
      head: {
        backgroundColor: KOBOO_LIGHT_GREY
      }
    },
    MuiTableCell: {
      root: {
        width: '130px',
      },
      body: {
        color: 'inherit'
      }
    }
  }
});

export default theme;



// WEBPACK FOOTER //
// ./src/theme/theme.js